/**
 * Oeffentliche Nutzungsbedingungen (ohne Login erreichbar).
 * URL fuer Google OAuth Consent Screen & TikTok App Audit.
 */
const Section = ({ title, children }) => (
  <section className="space-y-2">
    <h2 className="text-lg font-semibold">{title}</h2>
    <div className="text-sm leading-relaxed text-slate-600 space-y-2">{children}</div>
  </section>
);

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-white" data-testid="terms-page">
      <div className="max-w-3xl mx-auto px-6 py-12 space-y-8">
        <header className="space-y-2 border-b border-slate-200 pb-6">
          <p className="text-xs font-semibold tracking-widest text-[#2563EB] uppercase">InvictaFlow — InvictaX Group GmbH</p>
          <h1 className="text-3xl font-bold">Nutzungsbedingungen</h1>
          <p className="text-sm text-slate-500">Stand: Juni 2026 · Gilt für die Anwendung InvictaFlow (app.invictaflow.ch)</p>
        </header>

        <Section title="1. Geltungsbereich">
          <p>
            Diese Nutzungsbedingungen regeln die Verwendung der Anwendung InvictaFlow, einem internen
            Marketing-Betriebssystem der InvictaX Group GmbH, Bahnhofstrasse 75, 8620 Wetzikon, Schweiz. Die Anwendung ist für Mitarbeitende und
            beauftragte Personen der InvictaX Group GmbH und ihrer angeschlossenen Unternehmen bestimmt.
          </p>
        </Section>

        <Section title="2. Leistungsumfang">
          <p>
            InvictaFlow ermöglicht die Erstellung und Veröffentlichung von Social-Media-Inhalten
            (Meta, TikTok, LinkedIn), die Verwaltung von Werbekampagnen (Google Ads, Meta Ads),
            Website-Statistiken, SEO-Auswertungen sowie die Bearbeitung von Kundenanfragen (Leads).
            Ein Anspruch auf ununterbrochene Verfügbarkeit besteht nicht.
          </p>
        </Section>

        <Section title="3. Pflichten der Nutzenden">
          <p>Nutzende verpflichten sich:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Zugangsdaten vertraulich zu behandeln und nicht an Dritte weiterzugeben,</li>
            <li>nur Inhalte zu veröffentlichen, an denen sie die erforderlichen Rechte besitzen (Bilder, Videos, Musik, Texte),</li>
            <li>die Richtlinien der verbundenen Plattformen (Meta, TikTok, LinkedIn, Google) einzuhalten,</li>
            <li>keine rechtswidrigen, beleidigenden oder täuschenden Inhalte zu erstellen oder zu verbreiten.</li>
          </ul>
        </Section>

        <Section title="4. Verbundene Drittdienste">
          <p>
            Beim Verbinden von Social-Media- oder Werbekonten gelten zusätzlich die Bedingungen der
            jeweiligen Anbieter. Das Veröffentlichen auf TikTok setzt die Bestätigung der TikTok
            Music Usage Confirmation voraus. Die InvictaX Group GmbH haftet nicht für Änderungen,
            Einschränkungen oder Ausfälle dieser Drittdienste.
          </p>
        </Section>

        <Section title="5. KI-generierte Inhalte">
          <p>
            Die Anwendung erstellt Text-, Bild- und Videoinhalte mithilfe von KI-Diensten. Nutzende prüfen
            KI-generierte Inhalte vor der Veröffentlichung auf Richtigkeit und Rechtskonformität.
            Die Verantwortung für veröffentlichte Inhalte liegt beim jeweiligen Unternehmen.
          </p>
        </Section>

        <Section title="6. Haftung">
          <p>
            Die InvictaX Group GmbH haftet nur für direkte Schäden, die durch grobe Fahrlässigkeit oder Vorsatz
            verursacht wurden. Jede weitergehende Haftung, insbesondere für indirekte Schäden, entgangenen
            Gewinn oder Datenverlust, ist im gesetzlich zulässigen Rahmen ausgeschlossen.
          </p>
        </Section>

        <Section title="7. Datenschutz">
          <p>
            Informationen zur Bearbeitung von Personendaten finden Sie in unserer{" "}
            <a href="/privacy" className="text-[#2563EB] underline">Datenschutzerklärung</a>.
          </p>
        </Section>

        <Section title="8. Schlussbestimmungen">
          <p>
            Es gilt Schweizer Recht. Gerichtsstand ist der Sitz der InvictaX Group GmbH (Wetzikon ZH). Sollten einzelne
            Bestimmungen unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.
            Kontakt: <a href="mailto:info@strongfit.ch" className="text-[#2563EB] underline">info@strongfit.ch</a>
          </p>
        </Section>

        <footer className="pt-6 border-t border-slate-200 text-xs text-slate-400">
          InvictaX Group GmbH · Bahnhofstrasse 75 · 8620 Wetzikon · InvictaFlow · <a href="/privacy" className="underline">Datenschutzerklärung</a>
        </footer>
      </div>
    </div>
  );
}
